// extracted by mini-css-extract-plugin
export default {"host":"GridSelect_host__Ufs4O"};